import {FILTERS_GROUPS_IDS} from '../../common/filtersGroups.js'
import {FILTER_NAMES} from '../ads.js'

export const VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS = {
  [FILTERS_GROUPS_IDS.VEHICLE_TYPE_GROUP_ID]: {
    icon: 'carIndustrial',
    label: 'FILTERS_GROUPS.VEHICLE_TYPE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.CATEGORY_2]
  },
  [FILTERS_GROUPS_IDS.MAKE_GROUP_ID]: {
    icon: 'carDelivery',
    label: 'FILTERS_GROUPS.MAKE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.VERSION]
  },
  [FILTERS_GROUPS_IDS.PRICE_GROUP_ID]: {
    icon: 'tag',
    label: 'FILTERS_GROUPS.PRICE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.INSTALMENT, FILTER_NAMES.HAS_INSTALMENT, FILTER_NAMES.PRICE, FILTER_NAMES.HAS_PRICE_DROP]
  },
  [FILTERS_GROUPS_IDS.ONLINE_SERVICES_GROUP_ID]: {
    icon: 'cursorClick',
    label: 'FILTERS_GROUPS.ONLINE_SERVICES.LABEL.DEFAULT',
    filters: [FILTER_NAMES.HAS_RESERVATION, FILTER_NAMES.HAS_ONLINE_FINANCING]
  },
  [FILTERS_GROUPS_IDS.LOCATION_GROUP_ID]: {
    icon: 'poi',
    label: 'FILTERS_GROUPS.LOCATION.LABEL.DEFAULT',
    filters: [FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.ONLY_PENINSULA]
  },
  [FILTERS_GROUPS_IDS.SELLER_GROUP_ID]: {
    icon: 'shieldCheck',
    label: 'FILTERS_GROUPS.SELLER.LABEL.DEFAULT',
    filters: [FILTER_NAMES.SELLER_TYPE, FILTER_NAMES.RATING, FILTER_NAMES.HAS_WARRANTY, FILTER_NAMES.HAS_PHOTO]
  },
  [FILTERS_GROUPS_IDS.YEAR_GROUP_ID]: {
    icon: 'calendar',
    label: 'FILTERS_GROUPS.YEAR.LABEL.DEFAULT',
    filters: [FILTER_NAMES.YEAR]
  },
  [FILTERS_GROUPS_IDS.KMS_GROUP_ID]: {
    icon: 'kmOdometer',
    label: 'FILTERS_GROUPS.KMS.LABEL.DEFAULT',
    filters: [FILTER_NAMES.KMS]
  },
  [FILTERS_GROUPS_IDS.BODY_TYPE_GROUP_ID]: {
    icon: 'doors',
    label: 'FILTERS_GROUPS.BODY_TYPE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.SEAT]
  },
  [FILTERS_GROUPS_IDS.MOTOR_GROUP_ID]: {
    icon: 'carEngine',
    label: 'FILTERS_GROUPS.ENGINE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.FUEL_TYPE, FILTER_NAMES.HP]
  }
}
